var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "areaText" },
    [
      _c(
        "el-timeline",
        _vm._l(_vm.list, function (item, index) {
          return _c(
            "el-timeline-item",
            { key: index, attrs: { timestamp: item.times, placement: "top" } },
            [
              _c("el-card", [
                _c(
                  "div",
                  { staticClass: "imggs flex" },
                  [
                    _c("el-image", {
                      staticClass: "imgs",
                      attrs: { src: item.pic, "preview-src-list": _vm.imgList },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "wzDiv" }, [
                  _vm._v(" " + _vm._s(item.content) + " "),
                ]),
              ]),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }